import st from "lib/utils/index";
import BaseDecorator from "./BaseDecorator";

@BaseDecorator.translates(["location_name"])
export default class ProductLocationDecorator extends BaseDecorator {
  static build(data = {}) {
    return new this({
      uuid: st.generateUuid(),
      translations: [],
      ...data,
    });
  }
}



// WEBPACK FOOTER //
// ./src/lib/decorators/ProductLocationDecorator.js